export enum FutureOrderMode {
    ASAP = 0,
    TODAY = 1,
    FUTURE = 2,
}
